import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationOfferView: React.FC<React.PropsWithChildren<Props>> = ({
  theme,
  ...otherProps
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="304"
      height="304"
      fill="none"
      viewBox="0 0 304 304"
      {...otherProps}
    >
      <path stroke="#C0C2C9" d="M10 297.5L300 297.5"></path>
      <path
        fill="#F0F1F3"
        d="M278.294 46.075l-1.748-2.875C261.831 18.976 235.227 4.372 207.17 6.145c-3.618.228-7.214.72-10.76 1.471-25.501 5.455-47.694 24.721-56.894 49.395-5.38 14.51-6.92 31.224-17.189 42.738-13.362 14.993-36.046 15.45-55.986 14.839-19.94-.611-42.643-.087-55.938 14.96C2.077 138.953-.573 152.388.1 164.997c1.795 33.434 25.084 63.314 54.755 78.166 29.67 14.853 64.56 16.183 97.002 9.654 45.488-9.157 88.683-34.294 114.668-73.115 25.986-38.821 32.556-91.716 11.769-133.627z"
      ></path>
      <ellipse
        cx="74.088"
        cy="29.402"
        fill="#F0F1F3"
        rx="17.686"
        ry="17.671"
      ></ellipse>
      <ellipse
        cx="286.314"
        cy="265.329"
        fill="#F0F1F3"
        rx="17.686"
        ry="17.671"
      ></ellipse>
      <g filter="url(#filter0_dd)">
        <path fill="#fff" d="M109.937 35.61H268.629V237.151H109.937z"></path>
        <path
          stroke="#F0F1F3"
          d="M109.937 35.61H268.629V237.151H109.937z"
        ></path>
      </g>
      <rect
        width="65.006"
        height="15.283"
        x="192.151"
        y="81.459"
        fill="#F0F1F3"
        rx="4"
      ></rect>
      <path
        fill={theme ? theme.primary[500] : '#888D9B'}
        d="M197.887 91.542c.375.128.759.229 1.148.3 2.909.558 5.913.111 8.556-1.273a4.823 4.823 0 001.311-1.042 3.261 3.261 0 00.792-1.644c.068-.329.07-.67.005-.999a2.476 2.476 0 00-.382-.915 1.782 1.782 0 00-.848-.603 1.708 1.708 0 00-1.026-.015 1.318 1.318 0 00-.484.27 1.393 1.393 0 00-.339.448 1.85 1.85 0 00-.14 1.127 4.106 4.106 0 001.022 1.984 9.387 9.387 0 003.704 2.647 8.63 8.63 0 004.8.448 5.197 5.197 0 002.348-1.073c.37-.282.668-.655.867-1.086.199-.431.293-.906.274-1.384a2.752 2.752 0 00-.511-1.35 2.063 2.063 0 00-1.171-.85 1.424 1.424 0 00-.753.05c-.243.083-.46.231-.632.429a2.226 2.226 0 00-.496 1.428 3.087 3.087 0 00.34 1.466c.25.444.595.822 1.008 1.104a8.792 8.792 0 002.652 1.104c1.8.532 3.763 1.111 5.763.64a5.343 5.343 0 002.652-1.497c.378-.383.676-.843.875-1.352a4.119 4.119 0 00.28-1.604 2.72 2.72 0 00-.222-1.023 2.632 2.632 0 00-.585-.853 1.782 1.782 0 00-1.956-.216c-.322.15-.581.416-.732.749a1.6 1.6 0 00-.09 1.065 3 3 0 001.156 1.598 14.76 14.76 0 006.666 2.64c1.165.209 2.362.1 3.475-.317a3.525 3.525 0 001.404-1.08 3.727 3.727 0 00.729-1.652 2.56 2.56 0 00-.369-1.74 2.386 2.386 0 00-1.394-1.032 1.596 1.596 0 00-.869.069 1.657 1.657 0 00-.716.518 2.741 2.741 0 00-.556 1.606 3.338 3.338 0 00.341 1.628 3.75 3.75 0 001.052 1.197 7.97 7.97 0 002.718 1.189c1.815.501 3.704.856 5.423.2a4.646 4.646 0 002.059-1.544 3.636 3.636 0 00.741-2.385 3.387 3.387 0 00-.993-2.091 2.148 2.148 0 00-.914-.57 2.087 2.087 0 00-1.064-.048h-.074v.077a6.13 6.13 0 001.482 4.107 5.977 5.977 0 002.6 1.844 4.657 4.657 0 001.941.263c.444-.07.666-.131.666-.131a4.944 4.944 0 01-2.57-.247 5.935 5.935 0 01-2.511-1.837 5.991 5.991 0 01-1.363-3.983l-.082.1c.318-.061.646-.04.954.06.309.102.589.28.817.519.512.513.83 1.2.896 1.937.111 1.544-1.081 3.088-2.637 3.644-1.556.555-3.445.27-5.245-.24a7.705 7.705 0 01-2.607-1.15 3.433 3.433 0 01-.948-1.08 2.938 2.938 0 01-.297-1.452c.011-.501.177-.986.475-1.381.15-.19.346-.333.567-.416.222-.082.461-.102.692-.055.483.136.901.453 1.174.89.274.437.383.964.307 1.48a3.327 3.327 0 01-.662 1.467 3.15 3.15 0 01-1.256.956 6.221 6.221 0 01-3.289.286 14.35 14.35 0 01-6.482-2.578 2.664 2.664 0 01-1.015-1.367c-.07-.266-.046-.55.069-.8.114-.249.31-.447.554-.558a1.43 1.43 0 011.533.162c.208.205.375.451.491.724.116.273.178.568.183.866a3.71 3.71 0 01-.257 1.438 3.584 3.584 0 01-.787 1.21 4.966 4.966 0 01-2.46 1.39c-1.866.447-3.785-.093-5.578-.626a8.628 8.628 0 01-2.54-1.05 2.877 2.877 0 01-.897-.965c-.2-.391-.302-.83-.296-1.273-.008-.431.135-.85.4-1.181.127-.15.29-.262.472-.326s.377-.076.565-.037c.382.136.718.385.966.717.249.332.4.732.434 1.15a2.64 2.64 0 01-.27 1.207 2.523 2.523 0 01-.782.932 4.96 4.96 0 01-2.222 1.011 8.358 8.358 0 01-4.622-.424 8.954 8.954 0 01-3.608-2.54 3.838 3.838 0 01-.963-1.822 1.31 1.31 0 01.079-.923c.137-.287.374-.508.662-.62.283-.089.586-.087.869.005.282.092.532.27.716.512.167.243.284.52.344.811.06.292.061.594.004.887a3.758 3.758 0 01-.702 1.505c-.342.439-.776.79-1.268 1.027a13.12 13.12 0 01-5.074 1.544 13.982 13.982 0 01-3.363-.124l-.867-.17a1.9 1.9 0 00-.237-.038z"
      ></path>
      <path
        fill="#575B66"
        d="M192.151 75.966c0-.128 8.562-.238 19.117-.238 10.555 0 19.122.11 19.122.238 0 .129-8.562.24-19.122.24s-19.117-.102-19.117-.24z"
      ></path>
      <rect
        width="65.006"
        height="15.283"
        x="121.409"
        y="81.459"
        fill="#F0F1F3"
        rx="4"
      ></rect>
      <path
        fill={theme ? theme.primary[500] : '#888D9B'}
        d="M180.679 91.542c-.375.128-.759.229-1.148.3-2.909.558-5.913.111-8.556-1.273a4.823 4.823 0 01-1.311-1.042 3.27 3.27 0 01-.793-1.644 2.524 2.524 0 01.378-1.914c.22-.284.515-.494.848-.603.333-.11.69-.115 1.026-.015.178.054.342.146.484.27.141.123.257.276.339.448.163.35.213.745.14 1.127a4.115 4.115 0 01-1.022 1.984 9.387 9.387 0 01-3.704 2.647 8.63 8.63 0 01-4.8.448 5.197 5.197 0 01-2.348-1.073 2.889 2.889 0 01-.867-1.086 3.017 3.017 0 01-.274-1.384c.048-.49.225-.958.511-1.35.281-.42.696-.721 1.171-.85.251-.051.51-.034.753.05.243.083.46.231.632.429.325.398.501.905.496 1.428a3.076 3.076 0 01-.341 1.466 3.277 3.277 0 01-1.007 1.104 8.792 8.792 0 01-2.652 1.104c-1.8.532-3.763 1.111-5.763.64a5.343 5.343 0 01-2.652-1.497 3.993 3.993 0 01-.875-1.352 4.119 4.119 0 01-.28-1.604c.007-.353.083-.7.221-1.023a2.65 2.65 0 01.586-.853 1.782 1.782 0 011.956-.216c.322.15.581.416.732.749a1.6 1.6 0 01.09 1.065 3 3 0 01-1.156 1.598 14.76 14.76 0 01-6.667 2.64c-1.164.209-2.361.1-3.474-.317a3.518 3.518 0 01-1.404-1.08 3.716 3.716 0 01-.729-1.652 2.56 2.56 0 01.369-1.74c.326-.512.823-.88 1.394-1.032.29-.058.59-.034.869.069.279.103.526.282.716.518.349.458.544 1.022.556 1.606a3.35 3.35 0 01-.341 1.628 3.75 3.75 0 01-1.052 1.197 7.974 7.974 0 01-2.719 1.189c-1.814.501-3.703.856-5.422.2a4.646 4.646 0 01-2.059-1.544 3.636 3.636 0 01-.741-2.385c.078-.799.431-1.542.993-2.091.254-.266.568-.462.914-.57a2.083 2.083 0 011.063-.048h.075v.077a6.13 6.13 0 01-1.482 4.107 5.977 5.977 0 01-2.6 1.844 4.657 4.657 0 01-1.941.263c-.444-.07-.666-.131-.666-.131a4.944 4.944 0 002.57-.247 5.935 5.935 0 002.511-1.837 5.991 5.991 0 001.363-3.983l.082.1a1.913 1.913 0 00-.955.06c-.308.102-.588.28-.816.519-.512.513-.83 1.2-.896 1.937-.111 1.544 1.081 3.088 2.637 3.644 1.556.555 3.444.27 5.245-.24a7.705 7.705 0 002.607-1.15c.386-.286.709-.654.948-1.08.221-.448.323-.949.296-1.452a2.373 2.373 0 00-.474-1.381 1.315 1.315 0 00-.567-.416 1.263 1.263 0 00-.692-.055 2.048 2.048 0 00-1.175.89 2.194 2.194 0 00-.306 1.48c.099.539.326 1.043.662 1.467a3.15 3.15 0 001.256.956 6.221 6.221 0 003.289.286 14.35 14.35 0 006.482-2.578 2.67 2.67 0 001.015-1.367c.07-.266.046-.55-.069-.8a1.125 1.125 0 00-.554-.558 1.43 1.43 0 00-1.533.162 2.25 2.25 0 00-.491.724 2.315 2.315 0 00-.183.866 3.69 3.69 0 00.257 1.438c.179.455.448.867.787 1.21a4.966 4.966 0 002.46 1.39c1.866.447 3.785-.093 5.578-.626a8.628 8.628 0 002.54-1.05c.367-.245.674-.575.897-.965.2-.391.302-.83.296-1.273a1.843 1.843 0 00-.4-1.181 1.093 1.093 0 00-.472-.326 1.055 1.055 0 00-.565-.037 2.09 2.09 0 00-.967.717 2.224 2.224 0 00-.433 1.15 2.64 2.64 0 00.27 1.207c.183.373.452.693.782.932a4.96 4.96 0 002.222 1.011 8.358 8.358 0 004.622-.424 8.954 8.954 0 003.608-2.54 3.838 3.838 0 00.963-1.822 1.31 1.31 0 00-.079-.923 1.232 1.232 0 00-.662-.62 1.426 1.426 0 00-.869.005c-.282.092-.532.27-.716.512-.167.243-.284.52-.344.811-.06.292-.061.594-.004.887.12.551.36 1.066.702 1.505.342.439.776.79 1.268 1.027a13.12 13.12 0 005.074 1.544c1.122.094 2.251.053 3.363-.124l.867-.17a1.87 1.87 0 01.237-.038z"
      ></path>
      <path
        fill="#575B66"
        d="M159.648 75.966c0 .129-8.562.24-19.117.24-10.556 0-19.122-.111-19.122-.24 0-.128 8.561-.238 19.122-.238 10.56 0 19.117.1 19.117.238z"
      ></path>
      <rect
        width="135.748"
        height="15.283"
        x="121.409"
        y="113.935"
        fill="#F0F1F3"
        rx="4"
      ></rect>
      <path
        fill={theme ? theme.primary[500] : '#888D9B'}
        d="M202.667 123.794c-.53.124-1.071.221-1.62.29-4.104.538-8.342.107-12.07-1.228a7.012 7.012 0 01-1.85-1.005c-.581-.44-.97-.991-1.118-1.585a1.68 1.68 0 01-.006-.963 2.07 2.07 0 01.539-.883c.31-.274.726-.476 1.196-.582a3.48 3.48 0 011.448-.014c.25.052.482.14.682.26.2.119.362.266.478.432.231.338.301.719.199 1.087-.218.722-.718 1.385-1.443 1.913-1.425 1.14-3.218 2.016-5.225 2.553-2.159.581-4.501.73-6.771.432-1.207-.147-2.344-.502-3.313-1.035-.522-.272-.942-.632-1.223-1.047a2.15 2.15 0 01-.386-1.335c.068-.473.317-.923.721-1.302.396-.405.981-.695 1.651-.819.354-.05.72-.033 1.062.047.343.081.65.224.892.414.459.384.708.873.7 1.377.013.493-.153.98-.48 1.415-.353.428-.839.792-1.422 1.064a15.966 15.966 0 01-3.741 1.064c-2.539.514-5.308 1.072-8.13.618-1.414-.218-2.712-.719-3.741-1.444-.533-.369-.954-.813-1.234-1.303a2.88 2.88 0 01-.396-1.548c.011-.34.117-.675.313-.986.196-.31.476-.59.826-.822a3.24 3.24 0 011.337-.388 3.54 3.54 0 011.422.179c.454.146.82.402 1.033.722.213.321.258.685.127 1.028-.281.63-.856 1.174-1.63 1.54-2.806 1.371-6.03 2.243-9.405 2.546a13.366 13.366 0 01-4.901-.305c-.773-.223-1.455-.581-1.981-1.042-.526-.461-.88-1.009-1.029-1.593-.124-.586.061-1.184.521-1.677.459-.494 1.16-.849 1.966-.995.41-.057.833-.034 1.226.066.394.099.742.272 1.01.499.492.441.768.985.784 1.549.036.544-.13 1.086-.481 1.57-.372.456-.878.85-1.483 1.154-1.17.545-2.47.933-3.836 1.146-2.56.484-5.225.826-7.649.194-1.144-.295-2.15-.81-2.905-1.489-.731-.65-1.103-1.468-1.045-2.3.11-.771.608-1.487 1.4-2.017a3.457 3.457 0 011.29-.549 4.268 4.268 0 011.5-.047h.105v.075c.032 1.461-.715 2.876-2.09 3.96-.978.815-2.244 1.429-3.668 1.778a9.41 9.41 0 01-2.738.254c-.627-.067-.94-.127-.94-.127 1.217.142 2.465.06 3.626-.238 1.378-.359 2.6-.97 3.542-1.772 1.292-1.064 1.978-2.434 1.923-3.84l.115.096a3.921 3.921 0 00-1.346.059 3.152 3.152 0 00-1.152.5c-.722.494-1.171 1.157-1.264 1.868-.157 1.489 1.526 2.977 3.72 3.513 2.195.536 4.859.261 7.399-.231a13.812 13.812 0 003.678-1.109 4.13 4.13 0 001.338-1.042c.311-.431.455-.914.418-1.399-.015-.484-.249-.952-.669-1.332a1.971 1.971 0 00-.801-.401 2.558 2.558 0 00-.976-.053c-.681.131-1.271.437-1.657.858-.385.422-.539.929-.433 1.427.14.52.461 1.006.934 1.415.473.408 1.083.725 1.773.922 1.487.376 3.086.471 4.64.275 3.283-.297 6.418-1.149 9.144-2.486.668-.314 1.171-.778 1.431-1.317a.825.825 0 00-.096-.772c-.161-.24-.439-.431-.782-.538a2.83 2.83 0 00-1.112-.138 2.616 2.616 0 00-1.051.294 2.36 2.36 0 00-.693.698 1.662 1.662 0 00-.258.835c-.014.475.109.947.362 1.387.254.439.632.836 1.112 1.166.955.672 2.158 1.137 3.469 1.34 2.634.432 5.34-.089 7.869-.603a15.725 15.725 0 003.584-1.012c.517-.236.95-.555 1.265-.93.282-.378.426-.801.418-1.229.01-.415-.19-.819-.565-1.138a1.69 1.69 0 00-.665-.315 2.16 2.16 0 00-.798-.035c-.539.131-1.012.371-1.363.691-.351.32-.563.706-.612 1.11a1.91 1.91 0 00.381 1.163c.259.359.638.668 1.103.899.919.501 1.995.836 3.135.975a16.98 16.98 0 006.521-.409c1.953-.506 3.701-1.348 5.089-2.449.674-.484 1.145-1.093 1.359-1.757a.91.91 0 00-.111-.891c-.194-.276-.528-.49-.934-.598a2.912 2.912 0 00-1.226.006c-.398.088-.75.26-1.011.493-.235.235-.4.501-.484.783a1.508 1.508 0 00-.007.855c.17.531.509 1.028.991 1.451.482.423 1.094.762 1.789.99 2.225.827 4.658 1.333 7.158 1.489 1.583.091 3.175.051 4.745-.119l1.222-.164c.11-.017.222-.03.335-.037z"
      ></path>
      <path
        fill="#575B66"
        d="M121.409 108.442c0 .129 8.561.239 19.117.239 10.555 0 19.122-.11 19.122-.239s-8.562-.239-19.122-.239-19.117.101-19.117.239z"
      ></path>
      <rect
        width="135.748"
        height="17.193"
        x="121.409"
        y="47.072"
        fill="#DBDDE1"
        rx="4"
      ></rect>
      <path
        fill="#575B66"
        d="M227.522 55.908c0 .128-17.123.239-38.234.239s-38.244-.11-38.244-.24c0-.128 17.123-.238 38.244-.238 21.12 0 38.234.101 38.234.239z"
      ></path>
      <rect
        width="65.006"
        height="15.283"
        x="192.151"
        y="174.111"
        fill="#F0F1F3"
        rx="4"
      ></rect>
      <path
        fill="#575B66"
        d="M192.151 168.619c0-.129 8.562-.239 19.117-.239 10.555 0 19.122.11 19.122.239 0 .128-8.562.238-19.122.238s-19.117-.101-19.117-.238z"
      ></path>
      <rect
        width="65.006"
        height="15.283"
        x="121.409"
        y="174.111"
        fill="#F0F1F3"
        rx="4"
      ></rect>
      <path
        fill="#575B66"
        d="M159.648 168.619c0 .128-8.562.238-19.117.238-10.556 0-19.122-.11-19.122-.238 0-.129 8.561-.239 19.122-.239 10.56 0 19.117.101 19.117.239z"
      ></path>
      <rect
        width="135.748"
        height="17.193"
        x="121.409"
        y="139.725"
        fill="#DBDDE1"
        rx="4"
      ></rect>
      <path
        fill="#575B66"
        d="M227.522 148.56c0 .129-17.123.239-38.234.239s-38.244-.11-38.244-.239c0-.128 17.123-.239 38.244-.239 21.12 0 38.234.101 38.234.239zM257.157 224.974c0 .129-17.123.239-38.234.239s-38.244-.11-38.244-.239c0-.128 17.123-.239 38.244-.239s38.234.101 38.234.239z"
      ></path>
      <path
        stroke={theme ? theme.secondary[700] : '#3F424B'}
        strokeWidth="2"
        d="M57.564 276.952c-2.932-8.398-10.449-40.589-13.84-55.636"
      ></path>
      <path
        fill={theme ? theme.secondary[700] : '#3F424B'}
        stroke={theme ? theme.secondary[700] : '#3F424B'}
        strokeWidth="2"
        d="M52.788 229.866c3.137-2.37 3.481-6.262 3.261-7.912-1.486.018-4.236-.59-7.024 1.99-2.358 2.183-2.819 4.735-3.055 7.401.927.129 3.681.891 6.818-1.479zM56.467 244.683c3.137-2.37 3.482-6.263 3.262-7.913-1.487.018-4.236-.59-7.025 1.991-2.358 2.182-2.819 4.735-3.055 7.401.927.129 3.681.89 6.818-1.479zM60.147 259.499c3.137-2.37 3.481-6.262 3.261-7.912-1.486.018-4.236-.59-7.024 1.99-2.358 2.182-2.819 4.735-3.055 7.401.926.129 3.681.891 6.818-1.479z"
      ></path>
      <path
        fill={theme ? theme.secondary[700] : '#3F424B'}
        stroke={theme ? theme.secondary[700] : '#3F424B'}
        strokeWidth="2"
        d="M39.249 233.014c-3.895-.659-5.97-3.963-6.52-5.533 1.344-.671 3.54-2.483 7.217-1.476 3.11.852 4.682 2.911 6.104 5.173-.775.544-2.906 2.494-6.801 1.836zM42.928 247.83c-3.895-.659-5.97-3.963-6.52-5.533 1.345-.671 3.54-2.482 7.218-1.475 3.11.851 4.681 2.91 6.103 5.173-.774.543-2.906 2.494-6.8 1.835zM46.608 262.646c-3.895-.658-5.97-3.963-6.52-5.532 1.344-.672 3.54-2.483 7.218-1.476 3.11.852 4.681 2.911 6.103 5.173-.775.543-2.906 2.494-6.8 1.835zM45.192 215.551c-.622-3.452-3.581-5.295-4.983-5.785-.585 1.191-2.177 3.134-1.247 6.393.786 2.757 2.633 4.152 4.66 5.415.475-.685 2.192-2.571 1.57-6.023z"
      ></path>
      <path
        stroke={theme ? theme.secondary[600] : '#575B66'}
        strokeWidth="2"
        d="M62.811 266.737L62.959 232.832"
      ></path>
      <path
        stroke={theme ? theme.secondary[600] : '#575B66'}
        strokeWidth="2"
        d="M63.007 259.895L72.211 246.67"
      ></path>
      <path
        stroke={theme ? theme.secondary[600] : '#575B66'}
        strokeWidth="2"
        d="M62.976 249.372L75.291 222.53"
      ></path>
      <circle
        cx="63.399"
        cy="225.351"
        r="5.848"
        fill={theme ? theme.secondary[600] : '#575B66'}
        stroke={theme ? theme.secondary[600] : '#575B66'}
        strokeWidth="4"
        transform="rotate(-19.134 63.399 225.351)"
      ></circle>
      <circle
        cx="78.644"
        cy="215.986"
        r="5.848"
        fill={theme ? theme.secondary[600] : '#575B66'}
        stroke={theme ? theme.secondary[600] : '#575B66'}
        strokeWidth="4"
        transform="rotate(-19.134 78.644 215.986)"
      ></circle>
      <circle
        cx="76.703"
        cy="241.109"
        r="5.848"
        fill={theme ? theme.secondary[600] : '#575B66'}
        stroke={theme ? theme.secondary[600] : '#575B66'}
        strokeWidth="4"
        transform="rotate(-19.134 76.703 241.109)"
      ></circle>
      <path
        fill={theme ? theme.primary[500] : '#C0C2C9'}
        d="M41.857 265.143H68.143V298H41.857z"
      ></path>
      <path
        fill={theme ? theme.primary[600] : '#A4A8B2'}
        d="M68.143 265.143H76.686V298H68.143z"
      ></path>
      <defs>
        <filter
          id="filter0_dd"
          width="163.692"
          height="206.541"
          x="107.437"
          y="33.61"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="0.5"></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow"
            result="effect2_dropShadow"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationOfferView;
